<!-- The speaker button of the app themes (shown by TopControls.vue and MobileBar.vue only while a theme other than Default
     is on). With a mouse: a click turns the sounds on or off, hovering shows the panel with music and effects
     (SoundPanel.vue). On a touch screen a tap opens the panel (with its own on / off), a tap outside closes it.
     The class sound-ctl keeps its clicks out of the general click sound (src/stores/sounds.ts). -->
<script setup lang="ts">
import { computed, ref } from 'vue'
import { usePopover } from '../composables/usePopover'
import SoundPanel from './SoundPanel.vue'
import { useI18n } from '../composables/useI18n'
import { useSoundsStore } from '../stores/sounds'

withDefaults(defineProps<{ btnClass?: string; iconClass?: string }>(), { btnClass: '', iconClass: 'text-xs' })
const { t } = useI18n()
const sounds = useSoundsStore()
sounds.load()
const open = ref(false)
const root = ref<HTMLElement | null>(null)
const muted = computed(() => sounds.settings.muted)
const canHover = () => typeof window.matchMedia === 'function' && matchMedia('(hover: hover) and (pointer: fine)').matches

function click() {
  if (canHover()) sounds.toggleMute()
  else open.value = !open.value
}
usePopover(open, root, { event: 'pointerdown' })
</script>

<template>
  <div ref="root" :class="['sound-ctl relative', { 'is-open': open }]">
    <button type="button" :title="t('Sounds: click to turn them on or off')" :aria-label="t('Sounds and music')" :aria-pressed="!muted"
      :class="[btnClass, muted ? 'text-gray-500' : 'text-brand']" @click="click">
      <i :class="['fas', muted ? 'fa-volume-xmark' : 'fa-volume-high', iconClass]"></i>
    </button>
    <div class="sound-pop absolute right-0 top-full mt-2 w-64 max-w-[calc(100vw-1.5rem)] bg-darkcard border border-gray-800 rounded-2xl shadow-2xl p-4 z-50 text-left">
      <SoundPanel compact />
    </div>
  </div>
</template>
